import { createApplicationFormSelector } from './createApplicationFormSelector';

export const selectEmployeePositionType = (state) =>
  createApplicationFormSelector(state, 'employee_position_type');
